export default "https://cdn-static.gokick.com/assets/eeaee1442152ca0221916151b947444cbee5198d/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";